import { render, staticRenderFns } from "./ApiToken.vue?vue&type=template&id=6cbed2b0&"
import script from "./ApiToken.vue?vue&type=script&lang=js&"
export * from "./ApiToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports